import { useEffect } from 'react';

export const useBGBannerPadding = (
  headerHeight: number,
  isHomePage: boolean,
  shouldBannerBeFixed = false,
  isHeaderFixed = false,
  selectors: string[] = ['.lotriver-bg-left', '.lotriver-bg-right']
) => {
  useEffect(() => {
    let frameId: number;

    const updatePadding = () => {
      selectors.forEach(selector => {
        const el = document.querySelector(selector);
        if (el instanceof HTMLElement) {
          const isFixed = getComputedStyle(el).position === 'fixed';

          el.style.paddingTop =
            !isHomePage && isFixed ? `${headerHeight}px` : '';

          if (!isFixed && shouldBannerBeFixed && isHeaderFixed) {
            el.style.position = 'fixed';
            el.style.paddingTop = `${headerHeight}px`;
            el.style.top = '0';
          }
        }
      });
      frameId = requestAnimationFrame(updatePadding);
    };

    updatePadding();

    return () => cancelAnimationFrame(frameId);
  }, [
    isHomePage,
    headerHeight,
    selectors.join(','),
    shouldBannerBeFixed,
    isHeaderFixed
  ]);
};
